import { PatchGeneralSettingsRequest } from '../../settings/general.settings';
import { RoomKey } from '../socket.room.key';
import { SocketRoomEvent } from '../tenant.notification.payload';

export const GeneralSettingEventType = {
    Patched: 'patched',
} as const;

export interface GeneralSettingPatchedPayload extends PatchGeneralSettingsRequest {
    user?: { _id: string; name: string };
}

export type GeneralSettingsRoomMessage =
    SocketRoomEvent<typeof GeneralSettingEventType.Patched, GeneralSettingPatchedPayload>;

export const GeneralSettingsRooms = {
    generalSettings: (): RoomKey<GeneralSettingsRoomMessage> => ({ key: 'settings:general' }),
};
